import React from 'react';
import CSS from 'csstype';
import { Picture, Source, Img } from '@xo-union/tk-component-picture';
import styles from './index.scss';
import { Maybe } from '../../../generated/graphql';

interface Props {
  themeId: Maybe<number>;
  mediaId?: string;
  mediaUrl?: string;
  type?: string;
}

const getSources = (type?: string) => {
  switch (type) {
    case 'invite':
    case 'mobile':
      return {
        defaultHeigth: 360,
        defaultWidth: 166,
        xsHeight: 270,
        xsWidth: 125,
        smHeight: 405,
        smWidth: 187,
        mdHeight: 360,
        mdWidth: 166,
        lgHeight: 721,
        lgWidth: 333,
        xlHeight: 1082,
        xlWidth: 500,
      };
    default:
      return {
        defaultWidth: 0,
        defaultHeight: 0,
        xsWidth: 400,
        xsHeight: 300,
        smWidth: 600,
        smHeight: 450,
        mdWidth: 300,
        mdHeight: 225,
        lgWidth: 800,
        lgHeight: 600,
        xlWidth: 1200,
        xlHeight: 900,
      };
  }
};

const ThemeListImage: React.FC<Props> = ({ themeId, mediaId, mediaUrl, type }) => {
  const lowResThumbBG: CSS.Properties = {
    backgroundImage: `url(${mediaUrl}~rs_${type === 'mobile' ? '50.108' : '160.120'})`,
  };
  const sources = getSources(type);
  return (
    <div
      className={`${styles.imageContainer} ${type === 'mobile' ? styles.mobile : styles.desktop}`}
      style={lowResThumbBG}
    >
      <Picture id={mediaId} lazy pixelDensities={[1]}>
        <Source viewport="xs" width={sources.xsWidth} height={sources.xsHeight} />
        <Source viewport="sm" width={sources.smWidth} height={sources.smHeight} />
        <Source viewport="md" width={sources.mdWidth} height={sources.mdHeight} />
        <Source viewport="lg" width={sources.lgWidth} height={sources.lgHeight} />
        <Source viewport="xl" width={sources.xlWidth} height={sources.xlHeight} />
        <Img width={sources.defaultWidth} height={sources.defaultHeight} key={themeId} />
      </Picture>
    </div>
  );
};

export default ThemeListImage;
